// Add your custom JS here.
jQuery(document).ready(function ($) {
  $('[data-bs-toggle="tooltip"]').tooltip();
});
